import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PlanGuard = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null; // or loader

  const plan = user?.plan?.toLowerCase();

  // block only free users
  if (plan === "free") {
    return <Navigate to="/update-plan" replace />;
  }

  return children;
};

export default PlanGuard;